import React, { ReactNode } from 'react';

type ButtonLinkType = {
  ariaCurrent?: boolean | 'false' | 'true' | 'page' | 'step' | 'location' | 'date' | 'time' | undefined;
  cssClasses?: string;
  ref: React.RefObject<HTMLAnchorElement>;
  titleText?: string;
  children?: ReactNode;
  ariaLabel?: string;
};
export function ButtonLink({ ariaCurrent, ariaLabel, cssClasses, ref, titleText, children }: ButtonLinkType) {
  return (
    // see this technique here: https://twitter.com/svinkle/status/1455577767530090498
    // role attribute is actually not needed, but maybe this is needed for testing
    // eslint-disable-next-line jsx-a11y/anchor-is-valid,jsx-a11y/no-redundant-roles
    <a
      href={undefined}
      role="link"
      aria-disabled="true"
      aria-current={ariaCurrent}
      aria-label={ariaLabel}
      ref={ref as React.RefObject<HTMLAnchorElement>}
      className={cssClasses}
      title={titleText}
    >
      {children}
    </a>
  );
}
